import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {StatusModalStates} from '@chekin/shared';
import {DealsProcessingView} from './DealsProcessingView';
import {
  CloseButton,
  ErrorMessage,
  ModalBody,
  ModalHeader,
  ModalSubtitle,
  ModalTitleText,
  Row,
  StyledModalGuestRegistered,
} from './styled';

type Props = {
  onClose: () => void;
  title: string;
  state?: StatusModalStates;
  errorMessage?: string;
  errorMessages?: string[];
  successSubtitle?: string | ReactNode;
  hasOffers?: boolean;
  onFinishProcess?: () => void;
  onNavigateToCart?: () => void;
};

export function GuestsProcessingModal({
  title,
  state,
  successSubtitle,
  errorMessage,
  errorMessages,
  onClose,
  hasOffers,
  onFinishProcess,
  onNavigateToCart,
}: Props) {
  const {t} = useTranslation();

  if (
    hasOffers &&
    (state === StatusModalStates.LOADING || state === StatusModalStates.SUCCESS)
  ) {
    return (
      <DealsProcessingView
        isRegistrationComplete={state === StatusModalStates.SUCCESS}
        registrationMessage={
          state === StatusModalStates.LOADING ? t('sending_your_data') : successSubtitle
        }
        onFinishProcess={onFinishProcess}
        onNavigateToCart={onNavigateToCart}
      />
    );
  }

  return (
    <StyledModalGuestRegistered>
      {state !== StatusModalStates.IDLE && (
        <ModalHeader>
          <Row className="modalTitle">
            <ModalTitleText className="kiosko:text-kiosko-l">{title}</ModalTitleText>
          </Row>
        </ModalHeader>
      )}
      <ModalBody>
        <Row>
          <ModalSubtitle className="kiosko:text-kiosko-m kiosko:leading-[60px] kiosko:mt-12 kiosko:w-full">
            {state === StatusModalStates.LOADING && t('it_could_take_seconds')}
            {state === StatusModalStates.SUCCESS && successSubtitle}
            {state === StatusModalStates.ERROR && (
              <>
                {errorMessages && errorMessages.length > 0 ? (
                  errorMessages.map((message, index) => (
                    <ErrorMessage key={index} style={{marginBottom: '8px'}}>
                      {message}
                    </ErrorMessage>
                  ))
                ) : (
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                )}
                <CloseButton width={195} primary label={t('ok')} onClick={onClose} />
              </>
            )}
          </ModalSubtitle>
        </Row>
      </ModalBody>
    </StyledModalGuestRegistered>
  );
}
